<template>
  <VThemeProvider
    class="e-page-error"
    :theme="props.theme"
    with-background
  >
    <div
      class="e-page-error__container"
      :class="{ 'brand-linear-gradient-background': props.branded }"
    >
      <FMarqueeText
        class="e-page-error__title"
        show-animation-override
        :speed="50"
      >
        <span :class="{ 'brand-linear-gradient-title': props.branded }">
          <slot name="title" />
        </span>
      </FMarqueeText>

      <div class="e-page-error__description">
        <p class="e-page-error__description-text text-16 text-sm-20 text-md-24">
          <slot name="description" />
        </p>

        <slot name="actions" />
      </div>
    </div>
  </VThemeProvider>
</template>

<script setup lang="ts">
export interface EPageErrorProps {
  theme?: ThemeOptions
  branded?: boolean
}
const props = withDefaults(defineProps<EPageErrorProps>(), {
  theme: 'light',
})
</script>

<style lang="scss" scoped>
@use '@fire-framework/styles/variables';
@use '@fire-framework/styles/responsive';

.e-page-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  aspect-ratio: 2/3;
  min-height: 100%;
  overflow: hidden;
  max-width: 100%;

  @include responsive.tablet-wide {
    aspect-ratio: 5/4;
  }
  @include responsive.desktop {
    aspect-ratio: 2/1;
  }
}

.e-page-error__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  flex: 1 0 0;
  gap: variables.spacer(12);
  padding: variables.spacer(20) 0;

  @include responsive.desktop {
    padding: variables.spacer(30) 0;
  }
}

.e-page-error__title {
  font-size: 48px;
  line-height: 120%;
  text-transform: uppercase;
  font-weight: variables.font-weight('semi-bold');
  white-space: nowrap;
  max-width: 100vw;

  @include responsive.tablet {
    font-size: 120px;
  }
  @include responsive.desktop {
    font-size: 200px;
  }
}

.e-page-error__description {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: variables.spacer(7);
  padding: 0 variables.spacer(4);

  @include responsive.tablet {
    gap: variables.spacer(9);
    padding: 0 variables.spacer(6);
  }
  @include responsive.desktop {
    margin: 0 auto;
    max-width: 1240px;
    gap: variables.spacer(11);
    padding: 0;
  }
}

.e-page-error__description-text {
  color: rgba(var(--v-theme-on-background), 0.6);
  font-weight: variables.font-weight('medium');
}
</style>
